<template>
  <div id="sandbox-home">
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="200"
        aspect-ratio=0.05
        position="center"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      />
    </v-card>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        
        <v-flex xs12 md3>
          <v-card color="grey darken-4">
            <v-card-title><h1>Date Picker</h1></v-card-title>
            <v-card-text><p>Calendar component with the current date outlined and the selected date displayed in the heading of the calendar.</p></v-card-text>
            <v-container fluid>
              <example-date-picker :date="date"/>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex xs12 md3>
          <v-card color="grey darken-4">
            <v-card-title primary-title><h1>Fish Card</h1></v-card-title>
            <v-card-text>
              <p>
                Example of fish information. To see a complete list of data that can be found with this example,
                 enter this command in a Linux terminal: 
                <code>$> curl https://fishbase.ropensci.org/species?species=acutirostre&amp;limit=1</code>
              </p>
            </v-card-text>
            <v-container fluid>
              <example-fish-otd></example-fish-otd>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex xs12 md3>
          <v-card color="grey darken-4">
            <v-card-title primary-title><h1>Simple Markdown Editor</h1></v-card-title>
            <v-card-text>
              <p>
                Simple text formatting (similar to text styling in Slack). For a list of commands, visit this link: 
                <v-btn exact href="https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet" flat color="accent">Markdown Cheatsheet</v-btn>
              </p>
            </v-card-text>
            <v-container fluid>
              <v-card light height="300">
                <example-markdown-editor></example-markdown-editor>
              </v-card>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex xs12 md3>
          <v-card color="grey darken-4">
            <v-card-title primary-title><h1>AmmoNyte Fish Profile</h1></v-card-title>
            <v-card-text>
              <p>
                View an example of how a user would access their profiles on the AmmoNyte main website.
              </p>
            </v-card-text>
            <v-container fluid>
              <v-layout column>
                <v-card height="300">
                  <v-card-text>
                    <ex-user-profile></ex-user-profile>
                  </v-card-text>
                </v-card>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import DatePicker from './examples/datepicker.vue'
import FishOTD from './examples/fishOTD.vue'
import MarkdownEditor from './examples/mdEditor.vue'
import UserProfile from './examples/fishProfile.vue'

export default {
  name: 'Sandbox',
  data () {
    return {
      titleImg: 'https://images.unsplash.com/photo-1506252374453-ef5237291d83?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=3ead6c185e05b3557d6a3846ed370616&auto=format&fit=crop&w=1268&q=80',
      date: '2018-10-20'
    }
  },
  components: {
    'example-date-picker': DatePicker,
    'example-fish-otd': FishOTD,
    'example-markdown-editor': MarkdownEditor,
    'ex-user-profile': UserProfile
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/sandbox/Sandbox.vue